

<table id="eventsPreview"> 
    
    
</table>

  <table *ngIf="false"> 
    <ng-container  *ngFor="let data of this.dataSource">
    <tr>
      <td style="text-align:center; ">
        <b *ngIf="isRedText(data.symbol)" style="color:red">{{data.strike}} </b>
        <b *ngIf="!isRedText(data.symbol)"  style="color:green">{{data.strike}} </b>
      </td>
      <td style="text-align:center;;padding-left:3px;padding-right:3px;color:#fff"> {{data.lastSize}}</td>
      <td style="text-align:center ">
        <span *ngIf="getTime(data.dateTime).includes('AM')" style="color:rgb(0, 247, 255)">{{ getTimeS(data.dateTime)}}</span>
        <span  *ngIf="getTime(data.dateTime).includes('PM')" style="color:rgb(234, 0, 255)">{{ getTimeS(data.dateTime)}}</span>
      </td>
    </tr>
    <tr>
      <td style="text-align:center "> 
        <span *ngIf="!data.itm" style="color:red">{{data.points}} </span>
        <span *ngIf="data.itm"  style="color:green">{{data.points}} </span>
        <span *ngIf="data.itm==null">{{data.points}} </span>
      </td>
      <td style="text-align:center;padding-left:3px;padding-right:3px; color:orange"> <span [innerHTML] = "data.tradeInfoPricePointsFixed"> </span></td>
      <td style="text-align:center "><div [innerHTML] = "this.sanitizer.bypassSecurityTrustHtml(data.costStrTable)" > </div></td>
    </tr>
 </ng-container>

 </table>


